import React, { Fragment } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

export default class TopNavBar extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    renderNavItem(text, url, icon) {
        return (
            <NavItem>
                <NavLink href={url}>
                    <span className={'navLinkIcon fa fa-' + icon}></span>
                    {text}
                </NavLink>
            </NavItem>
        )
    }

    renderDropdownToggle(text, icon) {
        return (
            <DropdownToggle nav caret={false}>
                <span className={'navLinkIcon fa fa-' + icon}></span>
                {text}
            </DropdownToggle>
        )
    }

    renderDropdownItem(text, url, icon) {
        return (
            <DropdownItem tag='div' className='nav-item'>
                <NavLink href={url}>
                    <span className={'navLinkIcon fa fa-' + icon}></span>
                    {text}
                </NavLink>
            </DropdownItem>
        )
    }

    renderLoggedIn() {
        return (
            <Nav navbar>
                <div className='ml-1' title='Logout'>
                    {this.renderNavItem('XManager', '/admin', 'th-list')}
                </div>
                {this.props.is_admin && <Fragment>
                    {this.renderNavItem('Parteneri', '/admin/providers', 'th-list')}
                    {this.renderNavItem('Rezervari Masini', '/admin/reservations', 'car')}
                    {this.renderNavItem('Rezervari Sofer', '/admin/services/drivers_reservations', 'male')}
                    <UncontrolledDropdown nav>
                        {this.renderDropdownToggle('Office', 'angle-down')}
                        <DropdownMenu className='navBgColor'>
                            {this.renderDropdownItem('Calendar Oferte', '/admin/provider/rental_calendars', 'calendar')}
                            {this.renderDropdownItem('Clienti', '/admin/users', 'address-book')}
                            {this.renderDropdownItem('Facturi si Comisioane', '/admin/bills', 'list-ul')}
                            {this.renderDropdownItem('Export Facturi', '/admin/invoices_summary', 'list-ul')}
                            {this.renderDropdownItem('Email-uri trimise', '/admin/emails', 'envelope')}
                            {this.renderDropdownItem('Adauga Rezervare', '/admin/add_rental_reservations/step1', 'plus')}
                            {this.renderDropdownItem('Tutoriale', '/admin/tutorials', 'film')}
                            {this.renderDropdownItem('Notificare Parteneri', '/admin/newsletters/new', 'mail-reply-all')}
                            {/*{this.renderDropdownItem('Shuttle Aeroport', '/admin/services/transfers_reservations', 'plane')}*/}
                            {this.renderDropdownItem('Export recenzii', '/admin/export_ratings', 'list-ul')}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <UncontrolledDropdown nav>
                        {this.renderDropdownToggle('Setari Flota', 'angle-down')}
                        <DropdownMenu className='navBgColor'>
                            {this.renderDropdownItem('Modele Masini', '/admin/fleet/car_models', 'flag')}
                            {this.renderDropdownItem('Clase Auto', '/admin/fleet/car_classes', 'flag')}
                            {this.renderDropdownItem('Marci Auto', '/admin/fleet/car_brands', 'flag')}
                            {this.renderDropdownItem('Informatii inchirieri', '/admin/fleet/rental_informations', 'flag')}
                            {this.renderDropdownItem('Locatii', '/admin/locations', 'flag')}
                            {this.renderDropdownItem('Optionale', '/admin/fleet/optionals', 'flag')}
                            {this.renderDropdownItem('Masini cu Sofer', '/admin/services/driver_car_models', 'male')}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Fragment>}
                <UncontrolledDropdown nav>
                    {this.renderDropdownToggle('Seo', 'angle-down')}
                    <DropdownMenu className='navBgColor'>
                        {this.renderDropdownItem('Blog', '/admin/blog_posts', 'file-o')}
                        {this.renderDropdownItem('Poze Site', '/admin/photos', 'flag')}
                        {this.renderDropdownItem('SEO Pagini', '/admin/seo_pages', 'file')}
                        {this.renderDropdownItem('Variabile SEO', '/admin/seo_variables', 'sliders')}
                        {this.renderDropdownItem('Sterge cache', '/admin/clear_cache', 'trash')}
                        {this.props.is_admin && <Fragment>
                            {this.renderDropdownItem('Sitemap xml', '/admin/sitemaps', 'file')}
                            {this.renderDropdownItem('Link-uri Relative', '/admin/related_links', 'link')}
                            {this.renderDropdownItem('Vizitatori', '/admin/stats', 'link')}
                            {this.renderDropdownItem('Pagini Parteneri', '/admin/provider_pages', 'file')}
                            {this.renderDropdownItem('Afisare Parteneri', '/admin/static_providers', 'file')}
                        </Fragment>}
                    </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav>
                    {this.renderDropdownToggle('API', 'angle-down')}
                    <DropdownMenu className='navBgColor'>
                        {this.renderDropdownItem('Rezultate cautare', '/admin/api_offers', '')}
                        {this.renderDropdownItem('Setari masini, etc.', '/admin/api_items', '')}
                        {this.renderDropdownItem('Log rezervari', '/admin/api_operations', '')}
                    </DropdownMenu>
                </UncontrolledDropdown>
                <div className='ml-5' title='Logout'>
                    {this.renderNavItem('', '/admins/sign_out', 'sign-out')}
                </div>
            </Nav>
        )
    }

    renderLoggedOut() {
        return (
            <Nav navbar>
                {this.renderNavItem('Logare', '/admins/sign_in', 'sign-in')}
            </Nav>
        )
    }

    render() {
        return (
            <div>
                <Navbar className='navBgColor' dark expand="md">
                    <NavbarToggler onClick={this.toggle}/>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        {this.props.auth ? this.renderLoggedIn() : this.renderLoggedOut()}
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}